import { useState } from "react";
import { useAuthStore } from "./auth-store";

export function EmailSignupModal() {
  const { showEmailModal, loading, closeEmailModal, emailSignUp, signIn, clearError } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [existingUser, setExistingUser] = useState(false);
  const [signInError, setSignInError] = useState<string | null>(null);

  if (!showEmailModal) return null;

  function handleClose() {
    setEmail("");
    setPassword("");
    setExistingUser(false);
    setSignInError(null);
    clearError();
    closeEmailModal();
  }

  async function handleEmailSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSignInError(null);
    const result = await emailSignUp(email);
    if (result === "exists") {
      setExistingUser(true);
    }
  }

  async function handleSignIn(e: React.FormEvent) {
    e.preventDefault();
    setSignInError(null);
    try {
      await signIn(email, password);
      handleClose();
    } catch {
      setSignInError("Incorrect password. Please try again.");
    }
  }

  return (
    <div className="fixed inset-0 bg-black/80 z-[1000] flex items-center justify-center p-4" onClick={handleClose}>
      <div
        className="bg-th-surface border border-th-border rounded-xl p-6 w-full max-w-md shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-bold">
            {existingUser ? "Welcome Back" : "Get Started"}
          </h2>
          <button
            className="w-8 h-8 rounded-full bg-th-btn border border-th-border text-th-text-2 hover:bg-red-500 hover:text-white transition-colors"
            onClick={handleClose}
          >
            ✕
          </button>
        </div>

        {existingUser ? (
          <form onSubmit={handleSignIn} className="space-y-4">
            <p className="text-th-text-2 text-sm">
              You already have a Glossika account. Enter your password to sign in.
            </p>
            <input
              type="email"
              value={email}
              disabled
              className="w-full bg-th-input border border-th-border rounded-lg px-3 py-2 text-th-text text-sm opacity-60"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-th-input border border-th-border rounded-lg px-3 py-2 text-th-text text-sm"
              autoFocus
            />
            {signInError && (
              <p className="text-sm text-red-400">{signInError}</p>
            )}
            <button
              type="submit"
              disabled={loading || !password}
              className="w-full py-2.5 bg-glossika-600 hover:bg-glossika-500 text-white font-semibold rounded-lg transition-colors disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        ) : (
          <form onSubmit={handleEmailSubmit} className="space-y-4">
            <p className="text-th-text-2 text-sm">
              Enter your email to start learning for free.
            </p>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-th-input border border-th-border rounded-lg px-3 py-2 text-th-text text-sm"
              autoFocus
            />
            <button
              type="submit"
              disabled={loading || !email}
              className="w-full py-2.5 bg-glossika-600 hover:bg-glossika-500 text-white font-semibold rounded-lg transition-colors disabled:opacity-50"
            >
              {loading ? "Checking..." : "Continue"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
